import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSquareBehindSquare2"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4C22 2.89543 21.1046 2 20 2H10C8.89543 2 8 2.89543 8 4V8H4C2.89543 8 2 8.89543 2 10V20C2 21.1046 2.89543 22 4 22H14C15.1046 22 16 21.1046 16 20V16H20C21.1046 16 22 15.1046 22 14V4ZM16 14.5H20C20.2761 14.5 20.5 14.2761 20.5 14V4C20.5 3.72386 20.2761 3.5 20 3.5H10C9.72386 3.5 9.5 3.72386 9.5 4V8H14C15.1046 8 16 8.89543 16 10V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare2;
